import React, { Component } from 'react';
import { Col, Row, Tabs } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CustomContent from '../../components/Content/CustomContent';
import EditableTable from '../../components/EditableTable/EditableTable';
import EditableTableWithSelect from '../../components/EditableTable/EditableTableWithSelect';
import checkEnabledFeatures from '../../components/Authorization/Feature';
import {
  deleteBuildingAreasAction,
  getBuildingAreasAction,
  saveBuildingAreaAction,
} from '../../actions/SpecActions/BuildingAreaActions';
import {
  deleteCategoriesAction,
  getCategoriesAction,
  saveCategoryAction,
} from '../../actions/SpecActions/CategoryActions';
import {
  deleteSubCategoriesAction,
  getSubCategoriesAction,
  saveSubCategoryAction,
} from '../../actions/SpecActions/SubCategoryActions';
import EditableChildTable from '../../components/EditableTable/EditableChildTable';
import {
  deleteMaterialCatsAction,
  getMaterialCatsAction,
  saveMaterialCatAction,
} from '../../actions/SpecActions/MaterialCatActions';
import {
  deleteMaterialDetailsAction,
  getMaterialDetailsAction,
  saveMaterialDetailAction,
} from '../../actions/SpecActions/MaterialDetailActions';
import {
  deleteBuildingNumbersAction,
  getBuildingNumbersAction,
  saveBuildingNumberAction,
} from '../../actions/SpecActions/BuildingNumberActions';
import {
  deleteClassificationsAction,
  getClassificationsAction,
  saveClassificationAction,
} from '../../actions/SpecActions/ClassificationActions';
import {
  deleteCountriesAction,
  getCountriesAction,
  saveCountryAction,
} from '../../actions/SpecActions/CountryActions';
import {
  deleteCurrenciesAction,
  getCurrenciesAction,
  saveCurrencyAction,
} from '../../actions/SpecActions/CurrencyActions';
import {
  deleteGeoAreasAction,
  getGeoAreasAction,
  saveGeoAreaAction,
} from '../../actions/SpecActions/GeoAreaActions';
import {
  deleteLanguagesAction,
  getLanguagesAction,
  saveLanguageAction,
} from '../../actions/SpecActions/LanguageActions';
import {
  deleteLocationNamesAction,
  getLocationNamesAction,
  saveLocationNameAction,
} from '../../actions/SpecActions/LocationNameActions';
import {
  deleteSubjectsAction,
  getSubjectsAction,
  saveSubjectAction,
} from '../../actions/SpecActions/SubjectActions';
import {
  deleteSurfacesAction,
  getSurfacesAction,
  saveSurfaceAction,
} from '../../actions/SpecActions/SurfaceActions';
import {
  deleteTechnologiesAction,
  getTechnologiesAction,
  saveTechnologyAction,
} from '../../actions/SpecActions/TechnologyActions';
import {
  deleteConditionCatsAction,
  getConditionCatsAction,
  saveConditionCatAction,
} from '../../actions/SpecActions/ConditionCatActions';
import {
  deleteTreatmentCatsAction,
  getTreatmentCatsAction,
  saveTreatmentCatAction,
} from '../../actions/SpecActions/TreatmentCatActions';
import EditableTableWithColors from '../../components/EditableTable/EditableTableWithColors';
import './Settings.less';
import {
  deleteMovementReasonsAction,
  getMovementReasonsAction,
  saveMovementReasonAction,
} from '../../actions/SpecActions/MoveReasonActions';

const { TabPane } = Tabs;

function callback(key) {
  
}

class SettingsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: 0,
      selectedMaterialCategory: 0,
    };
  }

  handleCategorySelection = selectedId => {
    this.setState({
      selectedCategory: selectedId,
    });
  };

  handleMaterialCategorySelection = selectedId => {
    this.setState({
      selectedMaterialCategory: selectedId,
    });
  };

  render() {
    const {
      saveBuildingAreaAction: saveBuildingAreaAction1,
      buildingAreaList,
      deleteBuildingAreasAction: deleteBuildingAreasAction1,
      getBuildingAreasAction: getBuildingAreasAction1,
    } = this.props;
    const {
      getCategoriesAction: getCategoriesAction1,
      categoryList,
      saveCategoryAction: saveCategoryAction1,
      deleteCategoriesAction: deleteCategoriesAction1,
      categoryLoading,
    } = this.props;
    const { buildingAreaLoading } = this.props;
    const {
      saveSubCategoryAction: saveSubCategoryAction1,
      getSubCategoriesAction: getSubCategoriesAction1,
      deleteSubCategoriesAction: deleteSubCategoriesAction1,
      subcategoryList,
      subcategoryLoading,
    } = this.props;
    const { selectedCategory } = this.state;
    const {
      saveMaterialDetailAction: saveMaterialDetailAction1,
      getMaterialCatsAction: getMaterialCatsAction1,
      materialDetailLoading,
      deleteMaterialDetailsAction: deleteMaterialDetailsAction1,
      saveMaterialCatAction: saveMaterialCatAction1,
      materialDetailList,
      materialCatLoading,
      getMaterialDetailsAction: getMaterialDetailsAction1,
      materialCatList,
      deleteMaterialCatsAction: deleteMaterialCatsAction1,
    } = this.props;
    const { selectedMaterialCategory } = this.state;
    const {
      getBuildingNumbersAction: getBuildingNumbersAction1,
      saveClassificationAction: saveClassificationAction1,
      geoAreaList,
      subjectList,
      currencyLoading,
      getGeoAreasAction: getGeoAreasAction1,
      languageList,
      saveCountryAction: saveCountryAction1,
      geoAreaLoading,
      getCurrenciesAction: getCurrenciesAction1,
      saveLanguageAction: saveLanguageAction1,
      getTechnologiesAction: getTechnologiesAction1,
      technologyList,
      saveLocationNameAction: saveLocationNameAction1,
      saveSurfaceAction: saveSurfaceAction1,
      subjectLoading,
      getCountriesAction: getCountriesAction1,
      surfaceLoading,
      languageLoading,
      buildingNumberLoading,
      locationNameList,
      deleteLanguagesAction: deleteLanguagesAction1,
      deleteSurfacesAction: deleteSurfacesAction1,
      countryList,
      getSubjectsAction: getSubjectsAction1,
      currencyList,
      deleteBuildingNumbersAction: deleteBuildingNumbersAction1,
      deleteCurrenciesAction: deleteCurrenciesAction1,
      saveBuildingNumberAction: saveBuildingNumberAction1,
      deleteClassificationsAction: deleteClassificationsAction1,
      getClassificationsAction: getClassificationsAction1,
      deleteTechnologiesAction: deleteTechnologiesAction1,
      deleteLocationNamesAction: deleteLocationNamesAction1,
      saveTechnologyAction: saveTechnologyAction1,
      buildingNumberList,
      getLanguagesAction: getLanguagesAction1,
      getLocationNamesAction: getLocationNamesAction1,
      saveCurrencyAction: saveCurrencyAction1,
      deleteGeoAreasAction: deleteGeoAreasAction1,
      deleteSubjectsAction: deleteSubjectsAction1,
      surfaceList,
      deleteCountriesAction: deleteCountriesAction1,
      classificationLoading,
      classificationList,
      saveSubjectAction: saveSubjectAction1,
      technologyLoading,
      saveGeoAreaAction: saveGeoAreaAction1,
      getSurfacesAction: getSurfacesAction1,
      countryLoading,
      locationNameLoading,
    } = this.props;
    const {
      conditionCatList,
      deleteConditionCatsAction: deleteConditionCatsAction1,
      getConditionCatsAction: getConditionCatsAction1,
      saveConditionCatAction: saveConditionCatAction1,
      conditionCatLoading,
    } = this.props;
    const {
      treatmentCatList,
      deleteTreatmentCatsAction: deleteTreatmentCatsAction1,
      getTreatmentCatsAction: getTreatmentCatsAction1,
      saveTreatmentCatAction: saveTreatmentCatAction1,
      treatmentCatLoading,
    } = this.props;
    const {
      movementReasonLoading,
      getMovementReasonsAction: getMovementReasonsAction1,
      deleteMovementReasonsAction: deleteMovementReasonsAction1,
      saveMovementReasonAction: saveMovementReasonAction1,
      movementReasonList,
    } = this.props;
    const { currentUser } = this.props;

    return (
      <CustomContent>
        {/* <Tabs defaultActiveKey="1" onChange={callback} tabPosition="left"> */}
        <div className="customTab">
          <Tabs defaultActiveKey="1" onChange={callback} tabPosition="left">
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Category" key="1">
                <Row type="flex" justify="center">
                  <Col span={10}>
                    <EditableTable
                      dataSource={categoryList}
                      retrieveAll={getCategoriesAction1}
                      save={saveCategoryAction1}
                      delete={deleteCategoriesAction1}
                      parentSelection={this.handleCategorySelection}
                      cardTitle="Category List"
                      loading={categoryLoading}
                      parentType="setting"
                    />
                  </Col>
                  <Col span={1} />
                  <Col span={10}>
                    <EditableChildTable
                      dataSource={subcategoryList}
                      retrieveAll={getSubCategoriesAction1}
                      retrieveParam={selectedCategory}
                      save={saveSubCategoryAction1}
                      delete={deleteSubCategoriesAction1}
                      cardTitle="Subcategory List"
                      loading={subcategoryLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Building Area" key="2">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={buildingAreaList}
                      retrieveAll={getBuildingAreasAction1}
                      save={saveBuildingAreaAction1}
                      delete={deleteBuildingAreasAction1}
                      cardTitle="Building Area List"
                      loading={buildingAreaLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Materials" key="3">
                <Row type="flex" justify="center">
                  <Col span={10}>
                    <EditableTable
                      dataSource={materialCatList}
                      retrieveAll={getMaterialCatsAction1}
                      save={saveMaterialCatAction1}
                      delete={deleteMaterialCatsAction1}
                      parentSelection={this.handleMaterialCategorySelection}
                      cardTitle="Material Category List"
                      loading={materialCatLoading}
                      parentType="setting"
                    />
                  </Col>
                  <Col span={1} />
                  <Col span={10}>
                    <EditableChildTable
                      dataSource={materialDetailList}
                      retrieveAll={getMaterialDetailsAction1}
                      retrieveParam={selectedMaterialCategory}
                      save={saveMaterialDetailAction1}
                      delete={deleteMaterialDetailsAction1}
                      cardTitle="Material Detail List"
                      loading={materialDetailLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Building Number" key="4">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={buildingNumberList}
                      retrieveAll={getBuildingNumbersAction1}
                      save={saveBuildingNumberAction1}
                      delete={deleteBuildingNumbersAction1}
                      cardTitle="Building Number List"
                      loading={buildingNumberLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Classification" key="5">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={classificationList}
                      retrieveAll={getClassificationsAction1}
                      save={saveClassificationAction1}
                      delete={deleteClassificationsAction1}
                      cardTitle="Classification List"
                      loading={classificationLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Country" key="6">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={countryList}
                      retrieveAll={getCountriesAction1}
                      save={saveCountryAction1}
                      delete={deleteCountriesAction1}
                      cardTitle="Country List"
                      loading={countryLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Currency" key="7">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={currencyList}
                      retrieveAll={getCurrenciesAction1}
                      save={saveCurrencyAction1}
                      delete={deleteCurrenciesAction1}
                      cardTitle="Currency List"
                      loading={currencyLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Geographical Area" key="8">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={geoAreaList}
                      retrieveAll={getGeoAreasAction1}
                      save={saveGeoAreaAction1}
                      delete={deleteGeoAreasAction1}
                      cardTitle="Geographical Area List"
                      loading={geoAreaLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            <TabPane tab="Language" key="9">
              <Row type="flex" justify="center">
                <Col span={16}>
                  {/* <EditableTable
                    dataSource={languageList}
                    retrieveAll={getLanguagesAction1}
                    save={saveLanguageAction1}
                    delete={deleteLanguagesAction1}
                    cardTitle="Language List"
                    loading={languageLoading}
                    parentType="setting"
                  /> */}

                  <EditableTableWithSelect
                    dataSource={languageList}
                    retrieveAll={getLanguagesAction1}
                    save={saveLanguageAction1}
                    delete={deleteLanguagesAction1}
                    cardTitle="Language List"
                    loading={languageLoading}
                    parentType="setting"
                    location="setting"
                  />
                </Col>
              </Row>
            </TabPane>
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Location Name" key="10">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={locationNameList}
                      retrieveAll={getLocationNamesAction1}
                      save={saveLocationNameAction1}
                      delete={deleteLocationNamesAction1}
                      cardTitle="Location Name List"
                      loading={locationNameLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Subject" key="11">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={subjectList}
                      retrieveAll={getSubjectsAction1}
                      save={saveSubjectAction1}
                      delete={deleteSubjectsAction1}
                      cardTitle="Subject List"
                      loading={subjectLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Surface" key="12">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={surfaceList}
                      retrieveAll={getSurfacesAction1}
                      save={saveSurfaceAction1}
                      delete={deleteSurfacesAction1}
                      cardTitle="Surface List"
                      loading={surfaceLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Technology" key="13">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTable
                      dataSource={technologyList}
                      retrieveAll={getTechnologiesAction1}
                      save={saveTechnologyAction1}
                      delete={deleteTechnologiesAction1}
                      cardTitle="Technology List"
                      loading={technologyLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Condition Category" key="14">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTableWithColors
                      dataSource={conditionCatList}
                      retrieveAll={getConditionCatsAction1}
                      save={saveConditionCatAction1}
                      delete={deleteConditionCatsAction1}
                      cardTitle="Condition Category List"
                      loading={conditionCatLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Treatment Category" key="15">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTableWithColors
                      dataSource={treatmentCatList}
                      retrieveAll={getTreatmentCatsAction1}
                      save={saveTreatmentCatAction1}
                      delete={deleteTreatmentCatsAction1}
                      cardTitle="Treatment Category List"
                      loading={treatmentCatLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
            {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
              <TabPane tab="Movement Reason" key="16">
                <Row type="flex" justify="center">
                  <Col span={12}>
                    <EditableTableWithColors
                      dataSource={movementReasonList}
                      retrieveAll={getMovementReasonsAction1}
                      save={saveMovementReasonAction1}
                      delete={deleteMovementReasonsAction1}
                      cardTitle="Movement Reason List"
                      loading={movementReasonLoading}
                      parentType="setting"
                    />
                  </Col>
                </Row>
              </TabPane>
            )}
          </Tabs>
        </div>
      </CustomContent>
    );
  }
}

SettingsPage.propTypes = {
  getBuildingAreasAction: PropTypes.func,
  saveBuildingAreaAction: PropTypes.func,
  deleteBuildingAreasAction: PropTypes.func,
  buildingAreaList: PropTypes.array,
  buildingAreaLoading: PropTypes.bool,
  getCategoriesAction: PropTypes.func,
  saveCategoryAction: PropTypes.func,
  deleteCategoriesAction: PropTypes.func,
  categoryList: PropTypes.array,
  categoryLoading: PropTypes.bool,
  subcategoryLoading: PropTypes.bool,
  getSubCategoriesAction: PropTypes.func,
  saveSubCategoryAction: PropTypes.func,
  deleteSubCategoriesAction: PropTypes.func,
  subcategoryList: PropTypes.array,
  getMaterialCatsAction: PropTypes.func,
  saveMaterialCatAction: PropTypes.func,
  deleteMaterialCatsAction: PropTypes.func,
  materialCatList: PropTypes.array,
  materialCatLoading: PropTypes.bool,
  getMaterialDetailsAction: PropTypes.func,
  saveMaterialDetailAction: PropTypes.func,
  deleteMaterialDetailsAction: PropTypes.func,
  materialDetailList: PropTypes.array,
  materialDetailLoading: PropTypes.bool,
  getBuildingNumbersAction: PropTypes.func,
  saveBuildingNumberAction: PropTypes.func,
  deleteBuildingNumbersAction: PropTypes.func,
  buildingNumberList: PropTypes.array,
  buildingNumberLoading: PropTypes.bool,
  getClassificationsAction: PropTypes.func,
  saveClassificationAction: PropTypes.func,
  deleteClassificationsAction: PropTypes.func,
  classificationList: PropTypes.array,
  classificationLoading: PropTypes.bool,
  getCountriesAction: PropTypes.func,
  saveCountryAction: PropTypes.func,
  deleteCountriesAction: PropTypes.func,
  countryList: PropTypes.array,
  countryLoading: PropTypes.bool,
  getCurrenciesAction: PropTypes.func,
  saveCurrencyAction: PropTypes.func,
  deleteCurrenciesAction: PropTypes.func,
  currencyList: PropTypes.array,
  currencyLoading: PropTypes.bool,
  getGeoAreasAction: PropTypes.func,
  saveGeoAreaAction: PropTypes.func,
  deleteGeoAreasAction: PropTypes.func,
  geoAreaList: PropTypes.array,
  geoAreaLoading: PropTypes.bool,
  getLanguagesAction: PropTypes.func,
  saveLanguageAction: PropTypes.func,
  deleteLanguagesAction: PropTypes.func,
  languageList: PropTypes.array,
  languageLoading: PropTypes.bool,
  getLocationNamesAction: PropTypes.func,
  saveLocationNameAction: PropTypes.func,
  deleteLocationNamesAction: PropTypes.func,
  locationNameList: PropTypes.array,
  locationNameLoading: PropTypes.bool,
  getSubjectsAction: PropTypes.func,
  saveSubjectAction: PropTypes.func,
  deleteSubjectsAction: PropTypes.func,
  subjectList: PropTypes.array,
  subjectLoading: PropTypes.bool,
  getSurfacesAction: PropTypes.func,
  saveSurfaceAction: PropTypes.func,
  deleteSurfacesAction: PropTypes.func,
  surfaceList: PropTypes.array,
  surfaceLoading: PropTypes.bool,
  getTechnologiesAction: PropTypes.func,
  saveTechnologyAction: PropTypes.func,
  deleteTechnologiesAction: PropTypes.func,
  technologyList: PropTypes.array,
  technologyLoading: PropTypes.bool,
  getMovementReasonsAction: PropTypes.func,
  saveMovementReasonAction: PropTypes.func,
  deleteMovementReasonsAction: PropTypes.func,
  movementReasonList: PropTypes.array,
  movementReasonLoading: PropTypes.bool,
  getConditionCatsAction: PropTypes.func,
  saveConditionCatAction: PropTypes.func,
  deleteConditionCatsAction: PropTypes.func,
  conditionCatList: PropTypes.array,
  conditionCatLoading: PropTypes.bool,
  getTreatmentCatsAction: PropTypes.func,
  saveTreatmentCatAction: PropTypes.func,
  deleteTreatmentCatsAction: PropTypes.func,
  treatmentCatList: PropTypes.array,
  treatmentCatLoading: PropTypes.bool,
  currentUser: PropTypes.object,
};

function mapStateToProps({
  buildingAreaReducer,
  categoryReducer,
  subcategoryReducer,
  materialCatReducer,
  materialDetailReducer,
  buildingNumberReducer,
  classificationReducer,
  countryReducer,
  currencyReducer,
  geoAreaReducer,
  languageReducer,
  locationNameReducer,
  subjectReducer,
  surfaceReducer,
  technologyReducer,
  conditionCatReducer,
  treatmentCatReducer,
  movementReasonReducer,
  userReducer,
}) {
  const {
    buildingAreaList,
    loading: buildingAreaLoading,
  } = buildingAreaReducer;
  const { categoryList, loading: categoryLoading } = categoryReducer;
  const { subcategoryList, loading: subcategoryLoading } = subcategoryReducer;
  const {
    conditionCatList,
    loading: conditionCatLoading,
  } = conditionCatReducer;
  const {
    treatmentCatList,
    loading: treatmentCatLoading,
  } = treatmentCatReducer;
  const {
    buildingNumberList,
    loading: buildingNumberLoading,
  } = buildingNumberReducer;
  const {
    classificationList,
    loading: classificationLoading,
  } = classificationReducer;
  const { countryList, loading: countryLoading } = countryReducer;
  const { currencyList, loading: currencyLoading } = currencyReducer;
  const { geoAreaList, loading: geoAreaLoading } = geoAreaReducer;
  const { languageList, loading: languageLoading } = languageReducer;
  const {
    locationNameList,
    loading: locationNameLoading,
  } = locationNameReducer;
  const { subjectList, loading: subjectLoading } = subjectReducer;
  const { surfaceList, loading: surfaceLoading } = surfaceReducer;
  const { technologyList, loading: technologyLoading } = technologyReducer;
  const {
    movementReasonList,
    loading: movementReasonLoading,
  } = movementReasonReducer;
  const {
    materialDetailList,
    loading: materialDetailLoading,
  } = materialDetailReducer;
  const { materialCatList, loading: materialCatLoading } = materialCatReducer;
  const { currentUser } = userReducer;
  return {
    buildingAreaList,
    categoryList,
    buildingAreaLoading,
    subcategoryList,
    categoryLoading,
    subcategoryLoading,
    materialCatList,
    materialCatLoading,
    materialDetailList,
    materialDetailLoading,
    buildingNumberList,
    buildingNumberLoading,
    classificationList,
    classificationLoading,
    countryList,
    countryLoading,
    currencyList,
    currencyLoading,
    geoAreaList,
    geoAreaLoading,
    languageList,
    languageLoading,
    locationNameList,
    locationNameLoading,
    subjectList,
    subjectLoading,
    surfaceList,
    surfaceLoading,
    technologyList,
    technologyLoading,
    movementReasonList,
    movementReasonLoading,
    conditionCatList,
    conditionCatLoading,
    treatmentCatList,
    treatmentCatLoading,
    currentUser,
  };
}

export default connect(mapStateToProps, {
  getBuildingAreasAction,
  saveBuildingAreaAction,
  deleteBuildingAreasAction,
  getCategoriesAction,
  saveCategoryAction,
  deleteCategoriesAction,
  getSubCategoriesAction,
  saveSubCategoryAction,
  deleteSubCategoriesAction,
  getMaterialCatsAction,
  saveMaterialCatAction,
  deleteMaterialCatsAction,
  getMaterialDetailsAction,
  saveMaterialDetailAction,
  deleteMaterialDetailsAction,
  getBuildingNumbersAction,
  saveBuildingNumberAction,
  deleteBuildingNumbersAction,
  getClassificationsAction,
  saveClassificationAction,
  deleteClassificationsAction,
  getCountriesAction,
  saveCountryAction,
  deleteCountriesAction,
  getCurrenciesAction,
  saveCurrencyAction,
  deleteCurrenciesAction,
  getGeoAreasAction,
  saveGeoAreaAction,
  deleteGeoAreasAction,
  getLanguagesAction,
  saveLanguageAction,
  deleteLanguagesAction,
  getLocationNamesAction,
  saveLocationNameAction,
  deleteLocationNamesAction,
  getSubjectsAction,
  saveSubjectAction,
  deleteSubjectsAction,
  getSurfacesAction,
  saveSurfaceAction,
  deleteSurfacesAction,
  getTechnologiesAction,
  saveTechnologyAction,
  deleteTechnologiesAction,
  getMovementReasonsAction,
  saveMovementReasonAction,
  deleteMovementReasonsAction,
  getConditionCatsAction,
  saveConditionCatAction,
  deleteConditionCatsAction,
  getTreatmentCatsAction,
  saveTreatmentCatAction,
  deleteTreatmentCatsAction,
})(SettingsPage);
